export default "__VITE_ASSET__CVdsQOxx__"